import React, {Component} from 'react';
import FullScreen from './FullScreen';

//import domtoimage from 'dom-to-image';

import LogoBottom from './logos/logoBottom';
import LogoTop from './logos/logoTop';
import LogoLeft from './logos/logoLeft';
import LogoRight from './logos/logoRight';

import Header from "./Header"
import Loading from "./Loading"
import {Scrollbars} from 'react-custom-scrollbars';

const API_KEY = "AIzaSyD4QUaeyk-W40DDDfpgdRYj9e0mBOn7eJM";
const GOOGLE_FONTS_URL = "https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=" + API_KEY;


// const GOOGLE_FONTS_META_URL = "https://fonts.google.com/metadata/fonts";

class App extends Component {

    constructor(props) {
        super(props);

        this.aligns = {
            top: LogoTop,
            bottom: LogoBottom,
            left: LogoLeft,
            right: LogoRight
        }

        this.state = {
            controls: {
                fontSize: 25,
                letterSpacing: "0px",
                textTransform: "none",
                lineHeight: "30px",
                textAlign: "center"
            },
            logoSize: 100,
            logoMargin: 10,
            logoUrl: '',
            text: 'LogoText',
            fonts: [],
            allFonts: [],
            fontVisible: [],
            page: 0,
            isLoading: false,
            align: "bottom",
            logosPerRow: 4,
            scrollListStyles: {width: "calc(100vw - 240px)", height: "calc(100vh - 50px)", marginTop: 70}
        }

        this.onPrint();
        this.handleScroll = this.handleScroll.bind(this);
    }

    handleScroll() {
        if (this.isInViewport(this.pageChecker) && this.state.fonts.length - 1 > this.state.page) {
            const newPage = (this.state.page + 1);
            const allFonts = this.state.fontVisible.concat(this.state.fonts[newPage]);
            this.setState({page: newPage, fontVisible: allFonts});
        }
    }

 /*   downloadLogo(node, type) {

        const filter = (domNode) => {
            return !(domNode instanceof Element && domNode.className && domNode.className.includes("not-download"));

        }
        if (type === "png") {

            domtoimage.toPng(node, {filter: filter, bgcolor:"transparent"})
                .then((url) => {
                    let link = document.createElement('a');
                    link.download = 'logo.png';
                    link.href = url;
                    link.click();
                })
            .catch((err) => console.log(err))
        } else if (type === "svg") {
            domtoimage.toSvg(node, {filter: filter, bgcolor:"transparent"})
                .then((data) => {

                    console.log("load")

                    var blob1 = new Blob([data.replace("data:image/svg+xml;charset=utf-8,", "")], {type: "image/svg+xml"});
                    let url = window.URL.createObjectURL(blob1);

                    var a = document.createElement("a");
                    document.body.appendChild(a);
                    a.style = "display: none";
                    a.href = url;
                    a.setAttribute("download", "logo.svg");
                    a.click();
                    window.URL.revokeObjectURL(url);


                })
                .catch((err) => console.log({...err}))
        }


    } */


    onPrint() {
        const defaultStyles = {...this.state.scrollListStyles};
        window.onPrint = (callPrint) => {
            this.setState({
                scrollListStyles: {
                    marginTop: 0,
                    width: "100vw",
                    height: "100vh"
                }
            }, () => {

                if (callPrint) {
                    window.print();
                    window.onAfterPrint();
                }
            })
        }

        window.onAfterPrint = () => {
            this.setState({
                scrollListStyles: defaultStyles
            })
        }
    }


    componentWillMount() {
        this.fetchFonts();
    }

    chunks(arr, len) {
        var chunks = [],
            i = 0,
            n = arr.length;
        while (i < n) {
            chunks.push(arr.slice(i, i += len));
        }
        return chunks;
    }


    fetchFonts() {

        fetch(GOOGLE_FONTS_URL)
            .then(response => response.json())
            .then(data => {

                //this.fetchFontsMetaData(data.items);


                const fontsPage = this.chunks(data.items, 20);
                this.setState({
                    allFonts: data.items,
                    fonts: fontsPage,
                    fontVisible: fontsPage[0]
                }, () => {
                    //this.fetchFontsMetaData()
                });


            });
    }

    isInViewport(element = null, offset = 0) {
        if (!element) return false;
        const top = element.getBoundingClientRect().top;
        return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
    }

    getLogoStyles() {
        if (this.state.align === "top") {
            return {
                margin: "0 auto",
                marginTop: this.state.logoMargin,
            }
        }

        if (this.state.align === "bottom") {
            return {
                margin: "0 auto",
                marginBottom: this.state.logoMargin
            }
        }

        if (this.state.align === "left") {
            return {
                marginRight: this.state.logoMargin
            }
        }

        if (this.state.align === "right") {
            return {
                marginLeft: this.state.logoMargin
            }
        }
    }

    getFontsTTFUrl(files) {
        const choices = ["regular", "500", "600", "700", "900", "400", "300"];
        let url = "";

        for (let i = 0; i < choices.length; i++) {
            const style = choices[i];
            if (typeof files[style] === 'string' && files[style] !== "") {
                return files[style].replace("http://", "https://");
            }
        }

        return url.replace("http://", "https://");
    }

    textToHtml(html) {
        let arr = html.split(/<br\s*\/?>/i);
        return arr.reduce((el, a, idx) => el.concat(a, <br key={idx}/>), []);
    }


    renderLogos() {
        if (this.state.logoUrl === "") {
            return null;
        }

        if (this.state.fontVisible.length < 1) {
            return (
                <div className="flex w-full h-full justify-center items-center"><h1
                    className="text-center self-center font-light">No fonts available for your search</h1></div>
            );
        }


        const ComponentChoosed = this.aligns[this.state.align];

        let logoSize = "w-1/4";

        if (this.state.logosPerRow === 1) {
            logoSize = "w-full";
        } else {
            logoSize = "w-1/" + this.state.logosPerRow;
        }

        return (
            <div className="flex flex-row w-full align-center justify-center flex-wrap min-h-screen">
                {this.state.fontVisible.map((f, idx) => {
                    const safeFamily = f.family.toLowerCase().replace(/ /g, "-");
                    const textClass = " family-" + safeFamily;
                    const textStyle = {...this.state.controls, color: "#000", fontFamily: safeFamily};
                    const fontURL = this.getFontsTTFUrl(f.files);
                    const fontStyle = "@font-face {font-family:'" + safeFamily + "';src: url(" + fontURL + ") format('truetype');} .family-" + safeFamily + " {font-family:'" + safeFamily + "'!important;}";
                    const downloadURL = "https://fonts.google.com/specimen/" + f.family.replace(/ /g, "+");
                    const logoStyles = this.getLogoStyles();

                    //let ref = null;

                    return (
                        <div
                            onClick={() => window.open(downloadURL, '_blank')} key={idx}
                            className={logoSize + " p-8 bg-white hover:bg-grey-lighter overflow-hidden logo-item cursor-pointer"}
                        >
                            <h5 className="pb-4 opacity-50 text-black font-normal not-download">{f.family}</h5>
                            <ComponentChoosed
                                logoStyle={{
                                    width: this.state.logoSize,
                                    margin: 0,
                                    ...logoStyles
                                }} logoUrl={this.state.logoUrl}
                                fontStyle={fontStyle}
                                text={this.textToHtml(this.state.text)}
                                textClass={textClass}
                                fontURL={fontURL}
                                textStyle={textStyle}/>
                            {/* <div
                                className="download-btn opacity-0 m-2 not-download hidden flex flex-row justify-center items-center">
                                <a className="p-2 cursor-pointer" onClick={(evt) => {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                    this.downloadLogo(ref, "svg")
                                }}>SVG</a>
                                <a className="p-2 cursor-pointer" onClick={(evt) => {
                                    evt.preventDefault();
                                    evt.stopPropagation();
                                    this.downloadLogo(ref, "png")
                                }}>PNG</a>
                            </div> */}
                        </div>
                    )
                })}
            </div>
        );
    }


    onChangeControls(state) {
        this.setState({isLoading: true}, () => {
            this.setState({
                controls: state.controls,
                text: state.text,
                logoSize: state.logoSize,
                logoMargin: state.logoMargin,
                lineHeight: state.lineHeight,
                align: state.align,
                logosPerRow: state.logosPerRow
            }, () => {
                this.setState({isLoading: false});
            });
        });
    }

    onChangeSearchText(text) {

        let filterAllFonts = [...this.state.allFonts];

        if (text !== "") {
            filterAllFonts = filterAllFonts.filter((item) => {
                return item.family.toLowerCase().includes(text.toLowerCase());
            });
        }

        if (filterAllFonts.length > 1) {

            const fontsPage = this.chunks(filterAllFonts, 20);
            this.setState({
                fonts: fontsPage,
                fontVisible: fontsPage[0],
                page: 0
            });
        } else {
            this.setState({
                fontVisible: [],
                page: 0
            });
        }
    }

    render() {

        return (
            <div className="App">

                <Header
                    logoURL={this.state.logoUrl}
                    onClear={() => {
                        this.scrollList.scrollTop(0);
                        const fontsPage = this.chunks(this.state.allFonts, 20);
                        this.setState({page: 0, fontVisible: fontsPage[0]})

                    }}
                    searchText={(text) => this.onChangeSearchText(text)}
                    applyChange={(state) => this.onChangeControls(state)}
                />

                <div>

                    {this.state.logoUrl === "" &&
                    <div style={{marginTop: 80, padding: '0 20px'}}>
                        <FullScreen onDropFile={(files) => {
                            this.setState({logoUrl: files[0].preview});
                        }}/>
                    </div>
                    }


                    <Scrollbars
                        ref={(el) => this.scrollList = el}
                        onScroll={this.handleScroll}
                        className="logoZone"
                        style={this.state.scrollListStyles}
                    >


                        {this.renderLogos()}

                        {this.state.logoUrl !== "" &&
                        <div className="pageChecker" style={{width: 25, height: 25, position: "relative"}}
                             ref={(el) => this.pageChecker = el}/>
                        }
                    </Scrollbars>

                </div>


                {this.state.isLoading && (
                    <Loading/>
                )}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js